import React from 'react';
import { useCurrency } from './CurrencyContext';

const CurrencySwitcher = ({
  className = '',
  compact = false,
  selectClassName = '',
  labelClassName = '',
}) => {
  const { currency, setCurrency, supportedCurrencies, loading, lastUpdated } = useCurrency();
  const label = compact ? 'Cur' : 'Currency';
  const updatedLabel = lastUpdated ? new Date(lastUpdated).toLocaleTimeString() : 'updating';

  return (
    <label className={`flex items-center gap-2 text-xs ${labelClassName || 'text-slate-200'} ${className}`}>
      <span className={`uppercase tracking-[0.16em] text-[10px] ${labelClassName || 'text-slate-300'}`}>{label}</span>
      <select
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
        className={
          selectClassName ||
          'rounded-full border border-white/20 bg-white/10 px-2 py-1 text-xs text-white outline-none focus:border-emerald-300'
        }
        title={`Rates ${loading ? 'updating' : `updated ${updatedLabel}`}`}
      >
        {supportedCurrencies.map((code) => (
          <option key={code} value={code} className="text-slate-900">
            {code}
          </option>
        ))}
      </select>
    </label>
  );
};

export default CurrencySwitcher;
